import * as React from "react";
import { Alert } from "components/bootstrap";
import LicenseHelp from "./LicenseHelp";
const LicenseExpirationNotification = ({ expiredSince, products }) => {
  const productNames = products.length > 0 ? products.join(", ") : "Graylog";
  const licenseNoun = products.length > 1 ? "licenses" : "license";
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", className: "has-bm", title: "Graylog License Expired" }, /* @__PURE__ */ React.createElement("p", null, "Your", " ", /* @__PURE__ */ React.createElement("strong", null, productNames, " ", licenseNoun), " ", "expired ", expiredSince, " ago and the corresponding features have been disabled. ", /* @__PURE__ */ React.createElement(LicenseHelp, null)));
};
export default LicenseExpirationNotification;
